var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretLeftBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2359 6.63645C22.6341 7.02674 22.6703 7.63749 22.3445 8.06787L22.2359 8.19117L13.2499 17.0002L22.2359 25.8092C22.6341 26.1995 22.6703 26.8102 22.3445 27.2406L22.2359 27.3639C21.8378 27.7542 21.2148 27.7897 20.7758 27.4703L20.65 27.3639L10.8714 17.7775C10.4733 17.3872 10.4371 16.7765 10.7628 16.3461L10.8714 16.2228L20.65 6.63645C21.088 6.20712 21.798 6.20712 22.2359 6.63645Z",
    fill: "#5B7FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeftBlue);
export default __webpack_public_path__ + "static/media/caretLeftBlue.8b408c2dec7b54ad31f8afa4739a3b99.svg";
export { ForwardRef as ReactComponent };